import type {
  FocusHandler,
  BlurHandler,
} from '@noriginmedia/norigin-spatial-navigation'
import type { Collection } from '../../reducers/types/reducerTypes'

// Banner slug used to identify the injected banner collection
export const EVERGREEN_BANNER_SLUG = 'evergreen-urgent-banner'

export interface EvergreenMessagingConfig {
  bannerBackgroundColor: string
  bannerTextColor: string
  campaign: string
  ctaImageUrl?: string
  ctaText: string
  descriptionText: string
  displayUrl: string
  displayUrlTextColor: string
  headerText: string
  qrCodeImageUrl: string
  urlLink: string
}

// Default color constants
export const DEFAULT_BANNER_BACKGROUND_COLOR = '#0A145A' // PBS Navy Blue
export const DEFAULT_BANNER_TEXT_COLOR = '#FFFFFF' // White
export const DEFAULT_DISPLAY_URL_TEXT_COLOR = '#FFCF00' // PBS Yellow

export interface UseEvergreenMessagingReturn {
  shouldShowMessage: boolean
  loading: boolean
  error: Error | undefined
  messagingConfig: EvergreenMessagingConfig | undefined
  getCollectionsWithBanner: <T>(
    collections: Collection<T>[]
  ) => Collection<T | Record<string, never>>[]
}

// Internal type for API response (includes platform flags)
export interface EvergreenMessagingApiResponse
  extends EvergreenMessagingConfig {
  showMessageForAmazonOSTV: boolean
  showMessageForAndroid: boolean
  showMessageForApple: boolean
  showMessageForComcast: boolean
  showMessageForLGTV: boolean
  showMessageForRoku: boolean
  showMessageForSamsungTV: boolean
  showMessageForVizio: boolean
}

// EvergreenUrgentBanner component types
export interface EvergreenUrgentBannerProps {
  className?: string
  onFocus?: FocusHandler<void>
  onBlur?: BlurHandler<void>
}
